<template>
    <div class="phonenumber-input">
        <label for="phonenumber"
            class="form-label">
            {{ locale.PHONE }}
        </label>
        <MDBInput id="phonenumber"
            inputGroup
            type="tel"
            v-model="inputValue"
            class="m-0"
            :class="{ invalid: inputHasError || wrongPhoneFormat }"
            @blur="validateAndEmit" />
        <transition name="invalid">
            <div v-if="inputHasError"
                class="invalid-note">
                {{ locale.PHONE_REQUIRED }}
            </div>
        </transition>
        <transition name="invalid">
            <div v-if="wrongPhoneFormat"
                class="invalid-note">
                {{ locale.INVALID_PHONE_FORMAT }}
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "InputPhoneNumber",
    props: {
        modelValue: {
            type: String,
            default: ""
        },
        locale: {
            type: Object,
            required: true
        },
        hasError: {
            type: Boolean,
            default: false
        },
        validateProp: {
            type: Boolean,
            default: true
        }
    },
    emits: ["update:modelValue", "inputPhoneNumber"],
    data() {
        return {
            inputHasError: false,
            wrongPhoneFormat: false
        };
    },
    computed: {
        inputValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            }
        }
    },
    watch: {
        hasError(val) {
            this.inputHasError = val;
        }
    },
    methods: {
        validateAndEmit(event) {
            const value = event.target.value.trim();
            this.inputHasError = false;
            this.wrongPhoneFormat = false;
            if (!this.validateProp) {
                this.$emit("inputPhoneNumber", value);
                return;
            }
            if (!value) {
                this.inputHasError = true;
                return;
            }
            // Phone format Allows: digits, spaces, (), +, -, /
            const phoneRegex = /^[0-9()+\-\s/]{5,25}$/;
            if (!phoneRegex.test(value)) {
                this.wrongPhoneFormat = true;
                return;
            }
            this.$emit("update:modelValue", value);
            this.$emit("inputPhoneNumber", value);
        }
    }
};
</script>